import styled from "styled-components";

export const OutdatedWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    font-size: 90%;
`;

export const OutdatedLink = styled.a`
    color: inherit;
    display: inline-block;
    margin-left: 0.25em;
    text-decoration: none;
`;
